import React, { ReactElement, CSSProperties } from "react";
import ct from "class-types.macro";
import camelcase from "lodash/camelCase";
import ConnectForm from "./ConnectForm";
import InputBase from "./InputBase";
import { inputLabel, inputMessage } from "./inputStyles";
import InputError from "./InputError";
export type InputProps = {
  label: string;
  name?: string;
  id?: string;
  placeholder?: string;
  type?: "text" | "tel" | "password" | "date" | "email";
  required?: boolean;
  displayErrorMessage?: boolean;
  hintMessage?: string;
  children?: ReactElement;
  defaultValues?: string;
  labelClassName?: ClassTypes;
  labelExtra?: React.ReactNode;
  errorText?: string;
  labelStyle?: CSSProperties;
  style?: CSSProperties;
  className?: string;
  containerPadding?: boolean;
};
const NewItemsInput = ({
  label,
  type = "text",
  name = camelcase(label),
  id = name,
  placeholder = "",
  required = false,
  displayErrorMessage = true,
  hintMessage = "",
  defaultValues = "",
  labelClassName = inputLabel,
  labelExtra = null,
  errorText = label || "This field",
  children,
  className,
  style,
  labelStyle = {}
}: InputProps) => {
  return <ConnectForm data-sentry-element="ConnectForm" data-sentry-component="NewItemsInput" data-sentry-source-file="NewItemsInput.tsx">
      {({
      errors,
      clearErrors
    }) => {
      const error = errors[name];
      return <div className={ct("relative")}>
            {label ? <label htmlFor={id} className={labelClassName} style={labelStyle}>
                {label}{" "}
                {required ? <span className={ct("text-red-500")}>*</span> : ""}
                {labelExtra}
              </label> : null}
            <InputBase id={id} type={type} name={name} placeholder={placeholder} error={error} onFocus={() => {
          clearErrors(name);
        }} defaultValue={defaultValues} className={className} style={style} />
            {children}
            {(!displayErrorMessage || !error) && hintMessage !== "" && <span className={inputMessage}>{hintMessage}</span>}
            <InputError errors={errors} label={errorText} name={name} displayErrorMessage={displayErrorMessage} className="top-full text-red-100" />
          </div>;
    }}
    </ConnectForm>;
};
export default NewItemsInput;